import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StatusUpdateEventService {
  private approveEventSubject = new Subject<void>();
  private resetEventSubject = new Subject<number>();

  notifyApprove() {
    this.approveEventSubject.next();
  }

  notifyReset(status: number) {
    this.resetEventSubject.next(status);
  }

  onApproveRequested() {
    return this.approveEventSubject.asObservable();
  }

  onResetRequested() {
    return this.resetEventSubject.asObservable();
  }
}
